import { render } from "./PricingModal.vue?vue&type=template&id=51087c77&scoped=true&lang=pug"
import script from "./PricingModal.vue?vue&type=script&lang=ts"
export * from "./PricingModal.vue?vue&type=script&lang=ts"

import "./PricingModal.vue?vue&type=style&index=0&id=51087c77&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51087c77"

export default script